import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import theme from "./theme/theme";

import Sidebar, { DRAWER_WIDTH } from "./layout/Sidebar";
import Navbar from "./layout/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./components/AuthContext";

import Login          from "./pages/Login";
import Empleados      from "./pages/Empleados";
import Versiones      from "./pages/Versiones";
import Cursos         from "./pages/Cursos";
import Asignaciones   from "./pages/Asignaciones";
import Capacitaciones from "./pages/Capacitaciones";
import Dashboard      from "./pages/Dashboard";
import PerfilEmpleado from "./pages/PerfilEmpleado";
import AdminUsuarios  from "./pages/AdminUsuarios";
import AdminRoles     from "./pages/AdminRoles";
import Puestos        from "./pages/Puestos";
import Fichas         from "./pages/Fichas";
import Areas          from "./pages/Areas";
import Departamentos  from "./pages/Departamentos";
import ReporteHoras     from "./pages/ReporteHoras";
import ListaAsistencia from "./pages/ListaAsistencia";
import ListaAsistenciaVersiones from "./pages/ListaAsistenciaVersiones";
import Planes          from "./pages/Planes";
import PlanDetalle     from "./pages/PlanDetalle";

function AppLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar open={drawerOpen} onClose={() => setDrawerOpen(false)} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: { md: `${DRAWER_WIDTH}px` },
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "background.default",
        }}
      >
        <Navbar onMenu={() => setDrawerOpen(prev => !prev)} />

        <Box sx={{ p: { xs: 2, sm: 3 }, pt: { xs: "76px", sm: "84px" } }}>
          <Routes>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/"                element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard"       element={<Dashboard />} />
            <Route path="/empleados"       element={<Empleados />} />
            <Route path="/empleado/:id"    element={<PerfilEmpleado />} />
            <Route path="/cursos"          element={<Cursos />} />
            <Route path="/versiones"       element={<Versiones />} />
            <Route path="/asignaciones"    element={<Asignaciones />} />
            <Route path="/capacitaciones"  element={<Capacitaciones />} />
            <Route path="/admin/usuarios"  element={<AdminUsuarios />} />
            <Route path="/admin/roles"     element={<AdminRoles />} />
            <Route path="/puestos"         element={<Puestos />} />
            <Route path="/fichas"          element={<Fichas />} />
            <Route path="/areas"           element={<Areas />} />
            <Route path="/departamentos"   element={<Departamentos />} />
            <Route path="/reportes/horas" element={<ReporteHoras />} />
            <Route path="/planes"          element={<Planes />} />
            <Route path="/planes/:id"      element={<PlanDetalle />} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/lista-asistencia/:idCurso" element={
              <ProtectedRoute><ListaAsistencia /></ProtectedRoute>
            } />
            <Route path="/lista-asistencia-versiones/:idCurso" element={
              <ProtectedRoute><ListaAsistenciaVersiones /></ProtectedRoute>
            } />
            <Route path="*" element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
